import { combineReducers } from 'redux';

import isFetching from './isFetching';
import lastQueryText from './lastQueryText';
import queryText from './queryText';
import results from './results';

const search = combineReducers({
  isFetching,
  lastQueryText,
  queryText,
  results,
});

export default search;



// WEBPACK FOOTER //
// ./src/reducers/search/index.js